import React from "react"
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube, FaSpotify } from "react-icons/fa6"
import { StaticImage } from "gatsby-plugin-image"
import BaseIcon from "@/landing-page/components/icons/base_icon"
import LeiIncentivo from "@/landing-page/components/icons/lei_incentivo"

export function Footer() {
  return (
    <section className="bg-blue pt-10 pb-5 dark:bg-blue-dark dark:border-t">
      <div className="container">
        <div className="flex lg:flex-row flex-col-reverse items-center gap-5 justify-center relative border-b border-sand pb-5 mb-5">
          <div className="lg:absolute lg:-top-[1.125rem] lg:left-0 grid">
            <a
              href="/files/Regulamento_Elo-Feat-dos-Sonhos.pdf"
              target="_blank"
              title="Leia o regulamento"
              className="text-sand text-base font-bold lg:text-start text-center hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light"
            >
              REGULAMENTO
            </a>
            <a
              href="https://www.youtube.com/watch?v=hVydyJAtVKU"
              target="_blank"
              title="Acesse nosso regulamento em libras"
              className="text-sand text-base font-bold lg:text-start text-center hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light"
            >
              REGULAMENTO EM LIBRAS
            </a>
            <a
              href="mailto:atendimento@elofeatdossonhos.com.br"
              target="_blank"
              title="Fale Conosco"
              className="text-sand text-base font-bold lg:text-start text-center hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light"
            >
              FALE CONOSCO
            </a>
          </div>

          <div className="flex flex-col items-center">
            <span className="text-sand text-base font-bold mb-2">Siga o Feat dos Sonhos</span>

            <ul className="flex gap-2">
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61565378911620&_rdc=1&_rdr"
                  target="_blank"
                  title="Facebook"
                  className="text-sand text-xl"
                >
                  <FaFacebookF className="hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/elofeatdossonhos "
                  target="_blank"
                  title="Instagram"
                  className="text-sand text-xl"
                >
                  <FaInstagram className="hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@elofeatdossonhos"
                  target="_blank"
                  title="TikTok"
                  className="text-sand text-xl"
                >
                  <FaTiktok className="hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@elofeatdossonhos"
                  target="_blank"
                  title="Youtube"
                  className="text-sand text-xl"
                >
                  <FaYoutube className="hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light" />
                </a>
              </li>
              <li>
                <a
                  href="https://open.spotify.com/user/31d5wjhngiyc46jhrrthbqce3ity?si=duTBUFvbRyOjI_OMlpKPzw"
                  target="_blank"
                  title="Spotify"
                  className="text-sand text-xl"
                >
                  <FaSpotify className="hover:text-green-dark2 transition-all duration-300 ease-in-out dark:hover:text-blue-light" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <ul className="w-full flex flex-wrap items-center justify-around gap-4">
          <li className="lg:w-auto w-2/5">
            <LeiIncentivo aria-label="Logo Base" className="block w-36 h-auto text-sand" />
          </li>
          <li className="lg:w-auto w-2/5">
            <a href="https://www.elo.com.br/?utm_source=elofeatdossonhos&utm_medium=rodape" target="_blank" title="Elo">
              <StaticImage
                loading="lazy"
                src="../images/logo_elo.webp"
                alt="Logo Elo"
                width={148}
                height={93}
                className="object-contain block h-auto w-full lg:max-w-full max-w-28 m-0"
              />
            </a>
          </li>
          <li className="lg:w-auto w-2/5">
            <a href="https://www.cingulado.com.br" target="_blank" title="Cingulado">
              <StaticImage
                loading="lazy"
                src="../images/logo_cingulado.webp"
                alt="Logo Cingulado"
                width={252}
                height={93}
                className="object-contain block h-auto w-full lg:max-w-full max-w-60 m-0"
              />
            </a>
          </li>
          <li className="lg:w-auto w-2/5">
            <StaticImage
              loading="lazy"
              src="../images/logo_mdc.webp"
              alt="Logo Ministério da Cultura"
              width={255}
              height={64}
              className="object-contain block h-auto w-full lg:max-w-full max-w-60 m-0"
            />
          </li>
        </ul>

        <div className="border-t border-sand pt-5 mt-5">
          <a
            href="https://www.elo.com.br/?utm_source=elofeatdossonhos&utm_medium=sobre"
            target="_blank"
            title="Sobre a Elo"
          >
            <h3 className="text-sand text-xl font-bold mb-1">SOBRE A ELO</h3>
          </a>
          <p className="text-sand text-lg mb-8">
            A Elo é apoiadora incondicional da música brasileira. Apoiando e patrocinando diversos projetos que
            representam a diversidade e a pluralidade da nossa música.
          </p>

          <a href="https://www.cingulado.com.br" target="_blank" title="Sobre a Cingulado">
            <h3 className="text-sand text-xl font-bold mb-1">SOBRE A CINGULADO</h3>
          </a>
          <p className="text-sand text-lg">
            A Cingulado é uma consultoria especializada na idealização, planejamento e execução de projetos culturais e
            sociais.
          </p>
        </div>

        <div className="flex lg:flex-row flex-col gap-4 items-center justify-between border-t border-sand pt-5 mt-5">
          <span className="text-base text-sand">Copyright © 2024 Cingulado.</span>

          <a href="https://base.digital" title="Base Digital" target="_blank">
            <BaseIcon
              aria-label="Logo Base"
              className="block w-8 h-auto text-sand transition-all duration-300 ease-in-out hover:text-green-dark2"
            />
          </a>
        </div>
      </div>
    </section>
  )
}
